import React from 'react';
import { CreatorMessagesView } from './CreatorMessagesView';
import { useCreatorMessages } from './hooks/useCreatorMessages';
export const CreatorMessagesContainer = () => {
    const messages = useCreatorMessages();
    return (React.createElement(CreatorMessagesView, { vm: messages.creatorMessagesViewModel, showSendNewMessageButton: messages.showSendNewMessageButton }));
};
